module.exports = __webpack_public_path__ + "static/fleur_small_s-4513b803386f25d1d20befd9f38f0845.jpg";